import {EnvironmentModel, IOHURLS} from './environment.model';
import {Endpoints} from "./endpoints";


export const IOH: IOHURLS = {
  //userServiceBaseURL: 'http://localhost:3000',
  //patientServiceBaseURL: 'http://localhost:3001',
  //cdsServiceBaseUrl: 'http://localhost:3004',
  patientServiceBaseURL: 'https://portal.snd.iohealthtech.com',
  userServiceBaseURL: 'https://portal.snd.iohealthtech.com',
  cdsServiceBaseUrl: 'https://portal.snd.iohealthtech.com',
  rulesServiceBaseUrl: 'https://portal.snd.iohealthtech.com',
  reportsServiceBaseUrl: 'https://portal.snd.iohealthtech.com',
}

const endpoints = new Endpoints()
export const environment: EnvironmentModel= {
  production: false,
  posthogApiKey: 'ioh-client-telemetry',
  telemetryEnabled: true,
  cognito: {
    userPoolId: 'us-east-1_SUCPgjgWT',
    userPoolWebClientId: '30tp4ib1090m2vg6to24oa4gte',
    region: 'us-east-1',
    accessTokenExpiryMinutes: 30,
    refreshTokenExpiryMinutes: 60,
    sso: {
      domain: 'ioh-pool-snd.auth.us-east-1.amazoncognito.com',
      identityProvider: 'ioh-snd-idp-oidc',
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    },
  },
  endPoints: { ...endpoints.getGenericEndpoints()},
  awsCredentials: {
    region: "us-east-2",
    signatureVersion: "v4"
  }
}

